
export const TIME_ENTRY_PEOPLE_FIELDS = {
user_id: {
    type: "text",
    label: "User",
    isForeignKey: true,
    foreignKey: {
      referencedTable: "app_users",
      referencedColumn: "id",
      constraintName: "time_entries_user_id_fkey",
      onDelete: "CASCADE",
      onUpdate: "NO ACTION",
      relationKind: "many-to-one",
    },
    placeholder: "Current user (auto-filled)",
    required: true,
    excludeFromApi: true, // Don't include in API submission - it's auto-populated from auth
    validation: {
      required: "User is required.",
    },
    // Table properties
    sortable: true,
    filterable: true,
    searchable: true,
    resizable: true,
    hideable: true,
    editable: false, // Make it read-only since it's auto-populated
    filterType: "exact",
    width: 180,
    minWidth: 150,
    maxWidth: 250,
    icon: "User",
    // Which employee logged the time — internal, not exposed to clients.
    allowedRoles: ["wtc_employee", "wtc_admin"] as string[],
    groupable: true,
    mobileDetailSectionId: "context",
  },
approved_by: {
    type: "select",
    label: "Approved By",
    isForeignKey: true,
    foreignKey: {
      referencedTable: "app_users",
      referencedColumn: "id",
      constraintName: "time_entries_approved_by_fkey",
      onDelete: "SET NULL",
      onUpdate: "NO ACTION",
      relationKind: "many-to-one",
    },
    placeholder: "Select approver...",
    excludeFromApi: true, // Don't include in API submission for new entries
    // Table properties
    sortable: true,
    filterable: true,
    searchable: true,
    resizable: true,
    hideable: true,
    editable: false, // Read-only
    filterType: "exact",
    width: 180,
    minWidth: 150,
    maxWidth: 250,
    icon: "User",
    // Internal approval workflow — staff only.
    allowedRoles: ["wtc_employee", "wtc_admin"] as string[],
    mobileDetailSectionId: "approval",
  }
} as const;
